<template>
  <div>
    <div v-if="!newsDtlData" class="example3">
      <a-spin />
    </div>
    <fo-layout v-else>
      <div class="ta-c" v-if="loading">
        <a-spin />
      </div>
      <div v-else class="contact-news-dtl">
        <!-- 返回标签 -->
        <p class="pages-return-btn">
          <span @click="$router.push('/news')"><a-icon type="left" /> 返回</span>
        </p>
        <!-- 标题 -->
        <a-row :gutter="50">
          <a-col :sm="16">
            <h1 class="page-title">{{newsDtlData.news_title}}</h1>
          </a-col>
        </a-row>
        <a-row :gutter="50">
          <a-col :sm="16">
            <div class="subtitle down-solid">
              <span v-if="newsDtlData.news_atime">{{newsDtlData.news_atime.split(' ')[0]}}</span>
            </div>
            <div class="content-html" v-html="newsDtlData.news_content"></div>
          </a-col>
          <a-col :sm="8">
            <div class="down-solid">
              <div class="silver ta-c">其他资讯</div>
            </div>
            <!-- 内容 -->
            <template v-for="(item, index) in newsData">
              <div class="card-item" :key="index" v-if="index < 3">
                <h3 class="card-title to-2"
                  @click="$router.push('./' +  item.code)">{{item.news_title}}</h3>
                <p class="card-content to-3 silver" v-html="item.news_content.replace(/<p>/g, '')"></p>
                <!-- 跳转 -->
                <div class="card-btn">
                  <span class="primary"
                    @click="$router.push('./' +  item.code)">查看详情 <a-icon type="right" /></span>
                  <span class="fr">{{item.news_atime.split(' ')[0]}}</span>
                </div>
                <div class="title-border"><!-- 底边线 --></div>
              </div>
            </template>
          </a-col>
        </a-row>
      </div>
    </fo-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 加载状态
      loading: false,
      // 保存右侧客户数据
      newsData: [],
      // 保存左侧查询客户详情数据
      newsDtlData: [],
      // 客户查询条件
      newsCond: {
        // 第几页
        page_num: 1,
        // 每页多少条
        page_size: 5,
        // 关键词搜索
        keyword: '',
        // 按年搜索
        news_year: ''
      }
      // code...
    }
  },
  watch: {
    '$route' () {
      window.scroll(0, 0)
    },
    '$route.params.param' () {
      this.findItems()
      this.readItems()
    }
  },
  mounted () {
    this.findItems()
    this.readItems()
    // code...
  },
  methods: {
    /*
    * 查询点击客户的详细数据
    */
    findItems () {
      this.loading = true
      this.get({
        url: 'newsFind',
        data: {
          code: this.$route.params.param
        }
      }, (r) => {
        this.loading = false
        if (r.code) {
          this.newsDtlData = r.data
        } else {
          this.error(r.msg)
        }
      })
    },
    /*
    * 查询客户
    */
    readItems () {
      // this.newsData = []
      // var number = this.$route.query.total
      // this.newsCond.page_num = Math.ceil(Math.random() * number)
      this.loading = true
      this.get({
        url: 'newsRead',
        data: this.newsCond
      }, (r) => {
        this.loading = false
        if (r.code) {
          this.newsData = r.data.items.filter(item => item.code !== this.$route.params.param)
          // if (r.data.items.length >= 4) {
          //   for (var i of r.data.items) {
          //     if (this.newsData.length !== 3) {
          //       if (i.code !== this.$route.params.param) {
          //         this.newsData.push(i)
          //       }
          //     }
          //   }
          // } else {
          //   this.readItems()
          // }
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import url('../../utils/color.less');
  .contact-news-dtl {
    .page-title {
      font-weight: bold;
      font-family: Georgia, 宋体;
      margin-bottom: 20px;
    }
    .subtitle {
      margin-bottom: 30px;
      span {
        margin-right: 20px;
      }
    }
    .down-solid {
      width: 100%;
      border-bottom: 1px solid @graydark;
      height: 40px;
      font-size: 16px;
    }
    .card-item {
      padding-top: 30px;
      .card-title {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
        font-family: Georgia, 宋体;
      }
      .title-border {
        width: 100%;
        height: 2px;
        background: @graydark;
        &:after {
          content: '';
          display: block;
          width: 40px;
          height: 2px;
          transition: all .2s;
          background: @primary;
        }
      }
      &:hover {
        .card-title {
          color: @primary;
          cursor: pointer;
        }
        .title-border:after {
          width: 100%;
        }
      }
      .card-content {
        p {
          display: none;
        }
        p:first-child {
          display: block;
        }
      }
      .card-btn {
        padding: 10px 0 20px;
        .primary:hover {
          color: @support;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Models/newsDtl.vue